import React from 'react';

import { observer } from 'mobx-react-lite';

import Campaign from 'models/Campaign';
import { Upload } from '@vromo/models';
import ImageEditor from './ImageEditor';

interface Props {
    campaign: Campaign;
    onChangeLogo: (file?: File) => void;
}

export default observer<Props>(function Logo({ campaign, onChangeLogo }) {
    return (
        <div>
            <ImageEditor
                url={campaign.logo?.url || ''}
                onChange={({ url, file }) => {
                    onChangeLogo(file);
                    campaign.logo = file ? new Upload(url) : undefined;
                }}
            />
        </div>
    );
});
